import React from 'react';
import { Accordion } from 'components/accordion';
import GuidesToggleCardHeader from './guides-toggle-card-header';
import GuidesToggleCard from './guides-toggle-card';
import { Header4, P2 } from 'components/typography';
import { GuidesSidebarItemProps } from './guides-sidebar-item.type';
import ActiveLink from 'components/active-link/active-link';

const GuidesSidebarItem: React.FC<GuidesSidebarItemProps> = ({
    title,
    subtitle,
    index,
    isActive,
    url,
    backgroundColor,
}) => {
    const cardRef = React.useRef<HTMLDivElement>(null);

    return (
        <GuidesToggleCard
            isActive={isActive}
            backgroundColor={backgroundColor}
            isAlignedToTop={true}
        >
            <i ref={cardRef} />
            <Accordion.Toggle
                element={GuidesToggleCardHeader}
                eventKey={index}
                isActive={isActive}
                hasCloseActionIcon={true}
            >
                {url && !isActive ? (
                    <ActiveLink activeClassName="active">
                        <a className="guides-toggle-card-header__title-action" href={url}>
                            <Header4 color="var(--color-primary-01)" isResponsive={false}>
                                {title}
                            </Header4>
                            <div style={{ marginTop: 8 }}>
                                <P2 color="var(--color-primary-01)">{subtitle}</P2>
                            </div>
                        </a>
                    </ActiveLink>
                ) : (
                    <div className="guides-toggle-card-header__title-action">
                        <Header4 color="var(--color-primary-01)" isResponsive={false}>
                            {title}
                        </Header4>
                        <div style={{ marginTop: 8 }}>
                            <P2 color="var(--color-primary-01)">{subtitle}</P2>
                        </div>
                    </div>
                )}
            </Accordion.Toggle>
        </GuidesToggleCard>
    );
};

export default GuidesSidebarItem;
